import React, { useContext, useState } from "react";
import logo from "../../assets/logo2.png";
import styles from "./styles.module.css";
import { AuthContext } from "../../context";
import { Link, useNavigate } from "react-router-dom";
import { hooks } from "../../hooks";

const Navigation = ({ user }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [active, setActive] = useState(0);

  const posts = hooks.usePost();
  const handleChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    var dataFilter = posts.filter((x) => {
      return x.title.toLowerCase().includes(value.toLowerCase());
    });
    setShow(true);
    setFiltered(dataFilter);
  };

  const onClick = (suggestion) => {
    setActive(0);
    setFiltered([]);
    setShow(false);
    navigate("/post", { state: suggestion });
  };

  const renderAutocomplete = () => {
    if (show && search) {
      if (filtered.length) {
        return (
          <ul className={styles.autocomplete}>
            {filtered.map((suggestion, index) => {
              let className;
              if (index === active) {
                className = "active";
              }
              return (
                <li
                  className={className}
                  key={index}
                  onClick={() => onClick(suggestion)}
                >
                  {suggestion?.title}
                </li>
              );
            })}
          </ul>
        );
      } else {
        return (
          <ul className={styles.autocomplete}>
            <li>No Results</li>
          </ul>
        );
      }
    }
    return <div></div>;
  };
  return (
    <div className={styles.navigation}>
      <Link to="/" className={styles.logo}>
        <img src={logo} alt="Logo" />
        LBAN BLOG
      </Link>{" "}
      <Link className={`${styles.logo} ${styles.leads}`} to="/microsoft">
        Microsoft
      </Link>
      <div className={styles.inputContainer}>
        <input
          name="search"
          value={search}
          onChange={handleChange}
          placeholder="Search for Posts"
        />
        {renderAutocomplete()}
      </div>
      {/* {user ? (
        <p>Hi {user.firstname}!</p>
      ) : (
        <div className={styles.profile}>
          <Link to="/login" className="btn btnYellow">
            Sign In
          </Link>
          <Link to="/create-account" className="btn btnWhite">
            Create Account
          </Link>
        </div>
      )} */}
    </div>
  );
};

export default Navigation;
